// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ooamwjhmquoksnjtygkr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9vYW13amhtcXVva3NuanR5Z2tyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA0NDk3NTAsImV4cCI6MjA2NjAyNTc1MH0.uC-1uywoH13dP63NK_g3ICZik32Mcmaso-99fTguIlI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);